/**

 * Detect when webfonts are properly loaded and available!

 */

/* globals window, document */
/* exported window, document */
(function (window, document) {

	'use strict';

	/* jslint curly: false */
	/* jslint plusplus: true */
	/* jslint camelcase: false */
	/* jslint validthis: true */

	// by font key
	var resolved = {},
	    detecting = {},
	    containers = {};

	// maybe implement a more advance detection
	// use smart setup to trigger a scroll event
	// function fontDetectScroll(fontkey, font) {}

	// detect if a font is loaded by using
	// some divs to detect dimension change
	function fontDetectDom(fontkey, font)
	{

		// create the elements to be measured
		var webfont_div = document.createElement('div');
		var fallback_div = document.createElement('div');

		// setup the font family for the reference div
		fallback_div.style.fontFamily = font.fallback;
		// then setup the webfont div with same fallback as the reference div
		webfont_div.style.fontFamily = [font.family, font.fallback].join(', ');
		// store created divs so we can later remove them from document
		var divs = containers[fontkey] = [fallback_div, webfont_div];

		// apply common styles to all created divs
		for (var i = 0, L = divs.length; i < L; ++ i)
		{
			divs[i].style.fontWeight = font.weight;
			divs[i].style.fontStyle = font.style;
			divs[i].style.fontSize = '42px';
			divs[i].style.whiteSpace = 'nowrap';
			divs[i].style.position = 'absolute';
			divs[i].style.visibility = 'hidden';
			divs[i].style.left = '-9999px';
			divs[i].innerHTML = font.paragraph;
		}

		// now append the tests to the document
		// this could trigger the font download
		document.body.appendChild(fallback_div);
		document.body.appendChild(webfont_div);

		// create an array for further promises
		// we don't wait for them, we resolve them
		var promises = detecting[fontkey] = [];

		// return promise to resolve once font is loaded
		return new Promise(function (resolve, reject) {

			// closures
			var iv, tm;

			// store callbacks in internal array
			promises.push([resolve, reject]);

			// setup the timeout abort timer
			tm = window.setTimeout(function () {

				// clear the check interval
				if (iv) window.clearInterval(iv);
				// reject all waiting promises
				var i = promises.length; while (i--)
					promises[i][1]('timeout');
				// remove the created containers
				var n = divs.length; while (n--)
					document.body.removeChild(divs[n]);
				// remember the result
				resolved[fontkey] = false;
				// reset the array
				promises.length = 0;

			}, font.timeout || 4000);

			// closure function
			function check()
			{
				// check any dimensions have changed (success)
				if (webfont_div.offsetWidth != fallback_div.offsetWidth ||
				    webfont_div.offsetHeight != fallback_div.offsetHeight) {

					// load is complete, abort timers
					if (iv) window.clearInterval(iv);
					if (tm) window.clearTimeout(tm);
					// mark font ready (also via config object)
					// can be accessed before resolve is called
					font.ready = font.config.ready = true;
					// resolve all waiting promises
					var i = promises.length; while (i--)
						promises[i][0].call(this, font);
					// remove the created containers
					var n = divs.length; while (n--)
						document.body.removeChild(divs[n]);
					// remember the result
					resolved[fontkey] = font;
					// reset the array
					promises.length = 0;
				}
			}

			// this is the main testing interval
			iv = window.setInterval(check, font.interval || 40);

			// call once to trigger
			// one syncronized event
			// avoid fouc if possible
			check();

		});
		// EO Promise


	}
	// EO fontDetectDom

	var id = 0;

	// detect if a font is loaded by using
	// some divs to detect dimension change
	function fontDetect(family, config)
	{

		// ensure config object
		config = config || {};

		// split font families for fallbacks
		// avoid to get events from fallbacks
		var families = family.split(/\s*,\s*/);

		// poor man's extend
		var font = {
			id: ++id,
			ready: false,
			// mandatory
			config: config,
			family: families[0],
			families: families,
			// optional style settings
			style: config.style || 'normal',
			weight: config.weight || 'normal',
			effect: config.effect || 'normal',
			stretch: config.stretch || 'normal',
			variant: config.variant || 'normal',
			// timings for the tests
			timeout: config.timeout || 4000,
			interval: config.interval || 40,
			// properties for the tests
			paragraph: config.paragraph,
			fallback: config.fallback
		};

		// unique key for font
		// use to access hashmap
		var fontkey = [
			family,
			font.style,
			font.weight,
			font.effect,
			font.stretch,
			font.variant
		].join(':');

		// check if we already have a result
		if (typeof resolved[fontkey] != 'undefined')
		{
			return new Promise(function (resolve, reject) {
				var font = resolved[fontkey];
				if (resolved[fontkey]) resolve(font);
				else reject('timeout');
			});
		}

		// check if we already have a result
		if (typeof detecting[fontkey] != 'undefined')
		{
			return new Promise(function (resolve, reject) {
				// store callbacks in internal array
				detecting[fontkey].push([resolve, reject]);
			});
		}

		// try to be a little on the safe side
		// otherwise pass us a valid test font
		if (!font.fallback)
		{
			font.fallback = font.style == 'monospace' ?
			                'oblique' : 'monospace';
		}

		// initialize the test text
		if (!font.paragraph)
		{
			font.paragraph = [
				'0123456789',
				'!?\"\'\\#$(){}[]_',
				':;<>@~+-*%&^`|,=./',
				'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
				'abcdefghijklmnopqrstuvwxyz'
			].join(' ');
		}

		// now dispatch to implementors
		return fontDetectDom(fontkey, font);

	}

	// export into the window namespace
	window.fontDetect = fontDetect;

})(window, document);


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/utils/font-detect.js
// module id = 72
// module chunks = 0